import React from 'react';
import styled from 'styled-components';
import { MdCheckCircle, MdError } from 'react-icons/md';
import { useTranslation } from "react-i18next";

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    pointer-events: none;
`;

const ModalContainer = styled.div`
    width: 90%;
    max-width: 440px;
    padding: 2rem;
    background: rgba(30, 27, 75, 0.95);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    backdrop-filter: blur(16px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;
    gap: 1rem;
    color: rgba(255, 255, 255, 0.85);
    align-items: center;
    text-align: center;
    pointer-events: auto;
`;

const ModalHeader = styled.h2`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1.1rem;
    font-weight: 600;
    color: white;
`;

const ModalMessage = styled.p`
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.6);
    line-height: 1.6;
`;

const CloseButton = styled.button`
    padding: 0.55rem 1.8rem;
    border-radius: 12px;
    border: none;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    color: white;
    font-weight: 600;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 3px 14px rgba(99, 102, 241, 0.3);

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 5px 20px rgba(99, 102, 241, 0.45);
    }
    &:active { transform: translateY(0); }
`;

const ModalAlert = ({ title, message, isSuccess, isOpen, onClose, showCloseButton = true }) => {
    const { t } = useTranslation();

    if (!isOpen) return null;

    return (
        <ModalOverlay>
            <ModalContainer>
                <ModalHeader>
                    {isSuccess
                        ? <MdCheckCircle color="#6ee7b7" size={24} />
                        : <MdError color="#fca5a5" size={24} />}
                    {title}
                </ModalHeader>
                <ModalMessage>{message}</ModalMessage>
                {showCloseButton && (
                    <CloseButton onClick={onClose}>{t('CloseButton')}</CloseButton>
                )}
            </ModalContainer>
        </ModalOverlay>
    );
};

export default ModalAlert;
